module.exports = __webpack_public_path__ + "img/log_tit.e9e25d78.svg";